import { styled } from 'styled-components';
import { Utils } from 'team-hero-ui';

const { flexFn } = Utils;

export const LeaderCellContainerStyled = styled.div`
  ${flexFn()}
`;
